/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_codon_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It is the unequal use of synonymous codons — codons that encode the same amino acid. Genomes and highly expressed genes often prefer particular codons that match abundant tRNAs.`)
};

const es_codon_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es el uso desigual de codones sinónimos — codones que codifican el mismo aminoácido. Los genomas y los genes muy expresados suelen preferir determinados codones que coinciden con ARNt abundantes.`)
};

const de_codon_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es ist die ungleiche Nutzung synonymer Codons — Codons, die dieselbe Aminosäure kodieren. Genome und stark exprimierte Gene bevorzugen oft bestimmte Codons, die zu häufig vorkommenden tRNAs passen.`)
};

const nl_codon_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Het is het ongelijke gebruik van synonieme codons — codons die hetzelfde aminozuur coderen. Genomen en sterk tot expressie gebrachte genen geven vaak de voorkeur aan bepaalde codons die overeenkomen met overvloedige tRNA's.`)
};

const fr_codon_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`C'est l'utilisation inégale des codons synonymes — codons qui codent le même acide aminé. Les génomes et les gènes fortement exprimés préfèrent souvent certains codons qui correspondent à des ARNt abondants.`)
};

const it_codon_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`È l'uso diseguale dei codoni sinonimi — codoni che codificano lo stesso amminoacido. I genomi e i geni altamente espressi spesso preferiscono particolari codoni che corrispondono a tRNA abbondanti.`)
};

const pt_br2_codon_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`É o uso desigual de códons sinônimos — códons que codificam o mesmo aminoácido. Genomas e genes altamente expressos costumam preferir certos códons que combinam com tRNAs abundantes.`)
};

const pt_codon_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`É o uso desigual de codões sinónimos — codões que codificam o mesmo aminoácido. Os genomas e os genes altamente expressos preferem frequentemente determinados codões que correspondem a ARNt abundantes.`)
};

const ja_codon_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`同じアミノ酸をコードする同義コドンの不均等な使用のことです。ゲノムや高発現遺伝子は、豊富なtRNAに対応した特定のコドンを好むことが多くあります。`)
};

const zh_codon_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`它是指编码同一氨基酸的同义密码子被不均等使用的现象。基因组和高表达基因通常偏好与丰富 tRNA 相匹配的特定密码子。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const codon_faq_a1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.codon_faq_a1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("codon_faq_a1", locale)
	if (locale === "en") return en_codon_faq_a1(inputs)
	if (locale === "es") return es_codon_faq_a1(inputs)
	if (locale === "de") return de_codon_faq_a1(inputs)
	if (locale === "nl") return nl_codon_faq_a1(inputs)
	if (locale === "fr") return fr_codon_faq_a1(inputs)
	if (locale === "it") return it_codon_faq_a1(inputs)
	if (locale === "pt-BR") return pt_br2_codon_faq_a1(inputs)
	if (locale === "pt") return pt_codon_faq_a1(inputs)
	if (locale === "ja") return ja_codon_faq_a1(inputs)
	return zh_codon_faq_a1(inputs)
};